import { Box, Button, Paper, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";

import { BodyText, SubtitleText, TitleText } from "~/components/Typographies";
import Config from "~/config";
import TenantSwitcher from "~/layout/TenantSwitcher";

interface TenantInactiveProps {
	expiredTrial: boolean;
	onSignOut: () => void;
}

const TenantInactive = ({ expiredTrial, onSignOut }: TenantInactiveProps) => {
	const { t } = useTranslation("common");

	return (
		<Box
			sx={{
				alignItems: "center",
				bgcolor: "background.default",
				display: "flex",
				flexDirection: "column",
				gap: 2,
				justifyContent: "center",
				minHeight: "100vh",
				p: 2
			}}
		>
			<TenantSwitcher />
			<Paper elevation={3} sx={{ maxWidth: 480, p: 4, width: "100%" }}>
				<TitleText align="center" color="primary" gutterBottom sx={{ fontWeight: 700 }}>
					WorkSuite
				</TitleText>
				{expiredTrial ? (
					<Stack spacing={2}>
						<SubtitleText align="center">{t("errorPages.tenantInactive.trialEndedTitle")}</SubtitleText>
						<BodyText align="center" color="text.secondary">
							{t("errorPages.tenantInactive.trialEndedBody")}
						</BodyText>
						<Button color="primary" href={Config.salesContactUrl} variant="contained">
							{t("errorPages.tenantInactive.trialEndedCta")}
						</Button>
						<Button color="inherit" onClick={onSignOut} variant="text">
							{t("errorPages.tenantInactive.signOut")}
						</Button>
					</Stack>
				) : (
					<Stack spacing={2}>
						<SubtitleText align="center">{t("errorPages.tenantInactive.inactiveTitle")}</SubtitleText>
						<BodyText align="center" color="text.secondary">
							{t("errorPages.tenantInactive.inactiveBody")}
						</BodyText>
						<Button color="primary" href={Config.salesContactUrl} variant="contained">
							{t("errorPages.tenantInactive.inactiveCta")}
						</Button>
						<Button color="inherit" onClick={onSignOut} variant="text">
							{t("errorPages.tenantInactive.signOut")}
						</Button>
					</Stack>
				)}
			</Paper>
		</Box>
	);
};

export default TenantInactive;
